import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from "react-router-dom";
import './index.css'
import App from './App.tsx'

const root = document.documentElement;
root.style.setProperty('--primary', import.meta.env.VITE_PRIMARY);
root.style.setProperty('--primary-hover', import.meta.env.VITE_PRIMARY_HOVER);
root.style.setProperty('--primary-light', import.meta.env.VITE_PRIMARY_LIGHT);
root.style.setProperty('--secondary', import.meta.env.VITE_SECONDARY);
root.style.setProperty('--secondary-accent', import.meta.env.VITE_SECONDARY_ACCENT);
root.style.setProperty('--background-gradient-start', import.meta.env.VITE_BACKGROUND_GRADIENT_START);
root.style.setProperty('--background-gradient-middle', import.meta.env.VITE_BACKGROUND_GRADIENT_MIDDLE);
root.style.setProperty('--background-gradient-end', import.meta.env.VITE_BACKGROUND_GRADIENT_END);
root.style.setProperty('--text-primary', import.meta.env.VITE_TEXT_PRIMARY);
root.style.setProperty('--text-secondary', import.meta.env.VITE_TEXT_SECONDARY);
root.style.setProperty('--text-gray', import.meta.env.VITE_TEXT_GRAY);
root.style.setProperty('--text-gray-light', import.meta.env.VITE_TEXT_GRAY_LIGHT);
root.style.setProperty('--border-light', import.meta.env.VITE_BORDER_LIGHT);
root.style.setProperty('--border-orange', import.meta.env.VITE_BORDER_ORANGE);
root.style.setProperty('--success-bg', import.meta.env.VITE_SUCCESS_BG);
root.style.setProperty('--success-text', import.meta.env.VITE_SUCCESS_TEXT);
root.style.setProperty('--hover-shadow', import.meta.env.VITE_HOVER_SHADOW);
root.style.setProperty('--hover-border', import.meta.env.VITE_HOVER_BORDER);
root.style.setProperty('--gradient-primary', import.meta.env.VITE_GRADIENT_PRIMARY);
root.style.setProperty('--gradient-hero', import.meta.env.VITE_GRADIENT_HERO);
root.style.setProperty('--gradient-card', import.meta.env.VITE_GRADIENT_CARD);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
